module.exports = __webpack_public_path__ + "static/img/program-read-back.64f5fa9f.png";